import Select from 'react-select'
import React, { useEffect, useState } from 'react'
import Header from '../../../../../../../Components/Header/Header'
import Sidebar from '../../../../../../../Components/Sidebar/Sidebar'
import DeletePopup from '../../../../GardenPopup/DeletePopup'
import SeweragePumpingStationPopup from './SeweragePumpingPopup'
import { useAuthState } from '../../../../../../../Helper/Context'
import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Loading } from '../../../../../../../Helper/Loading'
import { SeverageWorkTypeDataDDL } from '../../../../../../../Components/CommonDDL/SeverageWorkTypeDataDDL'
import { SeveragePumpingStation, SeveragePumpingStationDataDDL } from '../../../../../../../Components/CommonDDL/SeveragePumpingStationDataDDL'
import { PumpingStationTableDataAPI } from '../../../../../../../Redux/SidebarMasterSlice/PumpingStationSlice'
import { WardNameDataDDL } from '../../../../../../../Components/CommonDDL/WardNameDataDDL'
import { PumpingStationMasterDeleteAPI, PumpingStationMasterExportTableDataAPI, PumpingStationMasterTableDataAPI } from '../../../../../../../Redux/SeverageDashboardSlice/SeveragePumpingStationMasterSlice'
import { Pegination } from '../../../../../../../Components/Pegination/Pegination'
import { SeweragePumpingExportData } from './SeweragePumpingExportData'

export default function SeweragePumpingData() {

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()

    const [searchParams] = useSearchParams()
    let searchName = searchParams.get("name")
    let ApiFlag = searchParams.get("ApiFlag")
    let HYear = searchParams.get("Year")
    let YLable = searchParams.get("YLable")
    let HMonth = searchParams.get("Month")
    let MLable = searchParams.get("MLable")
    let HWard = searchParams.get("WardName")
    let WLable = searchParams.get("WLable")
    let ProjectTypeId = searchParams.get("ProjectTypeId")
    let DashboardName = searchParams.get("DashboardName")

    // console.log(ApiFlag)

    // ----------pagination-------------
    const [PerPageCount, setPerPageCount] = useState(10)
    const [TotalCount, setTotalCount] = useState(0)
    const [To, setTo] = useState(10)
    const [From, setFrom] = useState(1)
    const [rowNo, setrowNo] = useState(1)
    const [CurrentPage, setCurrentPage] = useState(0)

    const [isSearch, setIsSearch] = useState(false)
    const [IsClear, setIsClear] = useState(false)
    const [IsPost, setIsPost] = useState(false)
    const [YearValue, setYearValue] = useState(0)
    const [ImagePopUpData, setImagePopUpData] = React.useState('')
    const [showImagePopup, setshowImagePopup] = React.useState(false)
    const [LocationMasterPopupShow, setLocationMasterPopupShow] = useState(false)
    const [DeletePopupShow, setDeletePopupShow] = useState(false)
    const [apiFlag, setapiFlag] = useState('')
    const [rowData, setrowData] = useState('')

    const [SewerageMasterPopupShow, setSewerageMasterPopupShow] = useState()

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: HWard && HWard ? HWard : '0',
        Label: WLable && WLable ? WLable : "Select...",
    })
    const [PumpingStation, setPumpingStation] = useState({
        DDL: [],
        ID: 0,
        Label: "Select...",
    })

    const handleAddOnClick = () => {
        setapiFlag('Insert')
        setSewerageMasterPopupShow(true)
    }

    const handleEditOnClick = (item) => {
        setSewerageMasterPopupShow(true)
        setapiFlag('Update')
        setrowData(item)
    }
    const handleOnCloseClick = () => {
        setSewerageMasterPopupShow(false)
    }

    const handleClear = () => {
        setTo(10)
        setFrom(1)
        setCurrentPage(0)
        setIsClear(!IsClear)
        setWardName({
            ...WardName,
            ID: HWard,
            Label: WLable,
        })
        setPumpingStation({
            ...PumpingStation,
            ID: 0,
            Label: 'Select...',
        })

        // console.log("call")
    }

    const handleIsPost = () => {
        setIsPost(!IsPost)
        // if (tableData && tableData.table && tableData.table.length > 0) {
        //     setCurrentPage(0)
        //     setFrom(1)
        //     setTo(10)
        // }

    }

    useEffect(() => {
        const data = {
            // FinancialYearID: YearValue,
            M_SW_PumpingStationWisePumpSetDetailsID: 0,
            M_WardID: WardName.ID,
            M_SW_PumpingStationID: PumpingStation.ID,
            PumpSetDetails: '',
            M_UserID: UserID,
            token: token,
            From: From,
            To: To,
            handlePumpingStationMasterExport:handlePumpingStationMasterExport
        }
        // if (WardName.ID !== 0) {
        dispatch(PumpingStationMasterTableDataAPI({ data }))
        // }

    }, [IsPost, To, isSearch, IsClear])

    const handleSearch = () => {
        setCurrentPage(0)
        setTo(10)
        setFrom(1)
        setIsSearch(!isSearch)
    }

    const handlePumpingStationMasterExport = () => {
        const data = {
            // FinancialYearID: YearValue,
            M_SW_PumpingStationWisePumpSetDetailsID: 0,
            M_WardID: WardName.ID,
            M_SW_PumpingStationID: PumpingStation.ID,
            PumpSetDetails: '',
            M_UserID: UserID,
            token: token,
            From: '1',
            To: '99999',
        }
        // if (WardName.ID !== 0) {
        dispatch(PumpingStationMasterExportTableDataAPI({ data }))
        // }

    }
    // , [IsPost, isSearch, IsClear])

    const { tableData, isLoading } = useSelector(state => state.PumpingStationMasterTableData)
    const { ExportTableData, isExportLoading } = useSelector(state => state.PumpingStationMasterExportTableData)

    const handleDeleteApi = (item) => {
        const data = {
            M_SW_PumpingStationWisePumpSetDetailsID: item.m_sW_PumpingStationWisePumpSetDetailsID,
            M_UserID: UserID,
            token: token,
            // Flag: 'Delete',
            handleIsPost: handleIsPost
        }

        dispatch(PumpingStationMasterDeleteAPI({ data }))
    }
    const { isDeleteLoading } = useSelector(state => state.SeverageWorkTypeDeleteData)

    // useEffect(() => {
    //     setCurrentPage(0)
    //     setFrom(1)
    //     setTo(10)
    // }, [PumpingStation.ID, WardName.ID])

    // const [SelectWard, setSelectWard] = useState({
    //     DDL: [],
    //     ID: 0,
    //     Label: "Select...",
    // })

    return (
        <>
            {isLoading && <Loading />}
            {isDeleteLoading && <Loading />}
            <div>
                <Header
                    // DashboardHeading="Sewerage Maintainance"                    
                    MLable={MLable}
                    HMonth={HMonth}
                    YLable={YLable}
                    HYear={HYear}
                    HWard={HWard}
                    WLable={WLable}
                    flag='Screen'
                    DashboardName={DashboardName}
                />
                <div className="wrapper">
                    <Sidebar ProjectTypeId={ProjectTypeId} />
                    <div className="content">
                        <div className='data_mob'>
                            <div className="row col-12 m-1 py-1 master_border">
                                <div className='col-5'>
                                    <h5 className="ps-1 py-1">Pumping Set Master</h5>
                                </div>
                                <div className='col-7 mar_add'>
                                    <div className="float-end butt">
                                        {
                                            isExportLoading ?
                                                <button type="button" className="btn btn-primary float-end mr-1 mb-1 ml-1" disabled>
                                                    <i
                                                        className="fa fa-refresh fa-spin"
                                                        style={{ marginRight: "5px" }}
                                                    />Loading</button>
                                                :
                                                tableData && tableData.table && tableData.table.length > 0 &&
                                                <SeweragePumpingExportData
                                                    ExcelData={ExportTableData}
                                                    name='Pumping Set Master'
                                                // searchName={searchName}
                                                />
                                        }
                                        <i className="fa-solid fa-plus float-end btn btn-secondary mb-2"
                                            style={{ color: "white" }}
                                            onClick={handleAddOnClick}
                                        >
                                            <text className="ml-2 poppins">Add</text>
                                        </i>
                                    </div>
                                </div>

                                <div className="row mt-0 m-0 ">
                                    <div className="col-12 py-2 rounded rounded-2 shadow"
                                        style={{ border: "1px solid #00000024", background: "#27466317" }}>
                                        <div className="col-12">
                                            <div className="row rounded2">

                                                <div className="col-12 col-lg-3 col-md-4">
                                                    <WardNameDataDDL
                                                        WardName={WardName}
                                                        setWardName={setWardName}
                                                        HWard={HWard}
                                                        WLable={WLable}
                                                    // Flag='ward'
                                                    />
                                                </div>

                                                <div className="col-12 col-lg-3 col-md-4">
                                                    <SeveragePumpingStationDataDDL
                                                        PumpingStation={PumpingStation}
                                                        setPumpingStation={setPumpingStation}
                                                        WardName={WardName.ID}

                                                    />

                                                </div>

                                                <div className="col-12 col-md-3 col-lg-3 mt-md-4 d-md-flex" >
                                                    <button type="button"
                                                        className="btn-clear btn btn-primary mx-2"
                                                        onClick={handleSearch}
                                                    >
                                                        Search</button>
                                                    <button type="button"
                                                        className="btn btn-outline-danger"
                                                        onClick={handleClear}
                                                    >
                                                        Clear</button>
                                                </div>
                                            </div>
                                            <div className="row mob_table table-responsive pt-2">
                                                <table id="totalordergenerated"
                                                    cellPadding="0"
                                                    cellSpacing="0"
                                                    border="0"
                                                    className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th className="sr_no_col">Sr No.</th>
                                                            <th>Ward Name</th>
                                                            <th>Pumping Station</th>
                                                            <th>Pump set Details</th>
                                                            <th className='action-col'>Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            tableData && tableData.table && tableData.table.length > 0 ? tableData.table.map((item) => (
                                                                <tr style={{ width: '100%' }}>
                                                                    <td className='sr-no-col' style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                                                    <td>{item.wardName ? item.wardName : '-'}</td>
                                                                    <td className='min-w-85'>{item.pumpingStation ? item.pumpingStation : '-'}</td>
                                                                    <td className='min-w-95'>{item.pumpSetDetails ? item.pumpSetDetails : '-'}</td>
                                                                    <td style={{ textAlign: "center", width: '7%' }}>
                                                                        <span >
                                                                            {/* <SeweragePumpingStationPopup
                                                                                open={SewerageMasterPopupShow}
                                                                                handleIsPost={handleIsPost}
                                                                                item={item}
                                                                                Flag='Update'
                                                                            /> */}
                                                                            <i className="fa-solid fa-pen-to-square" title='Edit'
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => handleEditOnClick(item)}
                                                                            >
                                                                            </i>
                                                                        </span>
                                                                        <span>
                                                                            <DeletePopup
                                                                                open={DeletePopupShow}
                                                                                handleDeleteApi={handleDeleteApi}
                                                                                item={item}
                                                                            />
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            )) :
                                                            <td colSpan={15}>No data found</td>
                                                        }
                                                    </tbody>
                                                </table>

                                            </div>
                                            {tableData && tableData.table && tableData.table.length > 0 &&
                                                <Pegination
                                                    PerPageCount={PerPageCount}
                                                    TotalCount={tableData.table[0].totalCount}
                                                    setFrom={setFrom}
                                                    setTo={setTo}
                                                    setrowNo={setrowNo}
                                                    CurrentPage={CurrentPage}
                                                    setCurrentPage={setCurrentPage}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
                {
                    SewerageMasterPopupShow ?
                        <SeweragePumpingStationPopup
                            open={SewerageMasterPopupShow}
                            popupHeading="Work Name Data"
                            handleIsPost={handleIsPost}
                            handleOnCloseClick={handleOnCloseClick}
                            Flag={apiFlag}
                            rowData={rowData}
                        />
                        : <></>
                }
            </div >
        </>
    )
}